import { PricingStrategy } from '@wix/ambassador-premium-domains-v1-recommendation/types';
const INTRO_PRICE_LABEL = 'domains_search_suite.anon_storefront_results.optimizations.container.intro_price.label';
const INTRO_PRICE_TOOLTIP = 'domains_search_suite.storefront.initial_vs_renewal.intro_price_tooltip';
const rowsFor = content => ({
  [PricingStrategy.FIRST_YEAR_MINOR_UNIT]: {
    priceFrom: 'price',
    strikethroughFrom: 'renewalPrice',
    labelKey: content.priceLabel,
    tooltipKey: content.priceTooltip,
    note: {
      labelKey: content.noteTwoYears,
      withIcon: true
    },
    cardNote: {
      labelKey: content.cardTwoYears,
      withIcon: true
    },
    perYear: false
  },
  [PricingStrategy.RENEWAL]: {
    priceFrom: 'price',
    strikethroughFrom: 'renewalPrice',
    labelKey: INTRO_PRICE_LABEL,
    tooltipKey: INTRO_PRICE_TOOLTIP,
    note: {
      labelKey: content.noteFirstYear,
      withIcon: false
    },
    cardNote: {
      labelKey: content.cardFirstYear,
      withIcon: true
    },
    requiresVoucher: true,
    perYear: true
  }
});

/**
 * A row whose claim asserts voucher eligibility only keeps it when the caller can prove it. The
 * strategy cannot: the arm's gated RENEWAL case and the ungated one emit identical payloads, so a
 * voucher row is indistinguishable from one with no coupon.
 */
export const withVoucherClaim = (row, eligible) => row != null && row.requiresVoucher && !eligible ? {
  ...row,
  note: undefined,
  cardNote: undefined
} : row;
export const perceptionRowFor = (price, content) => price != null && price.pricingStrategy ? rowsFor(content)[price.pricingStrategy] : undefined;
//# sourceMappingURL=perceptionRows.js.map